export interface ICity {
  value: string;
  label: string;
};

export const municipios: ICity[] =
    [
      {
        "value": "2600054",
        "label": "Abreu e Lima"
      },
      {
        "value": "2600104",
        "label": "Afogados da Ingazeira"
      },
      {
        "value": "2600203",
        "label": "Afrânio"
      },
      {
        "value": "2600302",
        "label": "Agrestina"
      },
      {
        "value": "2600401",
        "label": "Água Preta"
      },
      {
        "value": "2600500",
        "label": "Águas Belas"
      },
      {
        "value": "2600609",
        "label": "Alagoinha"
      },
      {
        "value": "2600708",
        "label": "Aliança"
      },
      {
        "value": "2600807",
        "label": "Altinho"
      },
      {
        "value": "2600906",
        "label": "Amaraji"
      },
      {
        "value": "2601003",
        "label": "Angelim"
      },
      {
        "value": "2601052",
        "label": "Araçoiaba"
      },
      {
        "value": "2601102",
        "label": "Araripina"
      },
      {
        "value": "2601201",
        "label": "Arcoverde"
      },
      {
        "value": "2601300",
        "label": "Barra de Guabiraba"
      },
      {
        "value": "2601409",
        "label": "Barreiros"
      },
      {
        "value": "2601508",
        "label": "Belém de Maria"
      },
      {
        "value": "2601607",
        "label": "Belém do São Francisco"
      },
      {
        "value": "2601706",
        "label": "Belo Jardim"
      },
      {
        "value": "2601805",
        "label": "Betânia"
      },
      {
        "value": "2601904",
        "label": "Bezerros"
      },
      {
        "value": "2602001",
        "label": "Bodocó"
      },
      {
        "value": "2602100",
        "label": "Bom Conselho"
      },
      {
        "value": "2602209",
        "label": "Bom Jardim"
      },
      {
        "value": "2602308",
        "label": "Bonito"
      },
      {
        "value": "2602407",
        "label": "Brejão"
      },
      {
        "value": "2602506",
        "label": "Brejinho"
      },
      {
        "value": "2602605",
        "label": "Brejo da Madre de Deus"
      },
      {
        "value": "2602704",
        "label": "Buenos Aires"
      },
      {
        "value": "2602803",
        "label": "Buíque"
      },
      {
        "value": "2602902",
        "label": "Cabo de Santo Agostinho"
      },
      {
        "value": "2603009",
        "label": "Cabrobó"
      },
      {
        "value": "2603108",
        "label": "Cachoeirinha"
      },
      {
        "value": "2603207",
        "label": "Caetés"
      },
      {
        "value": "2603306",
        "label": "Calçado"
      },
      {
        "value": "2603405",
        "label": "Calumbi"
      },
      {
        "value": "2603454",
        "label": "Camaragibe"
      },
      {
        "value": "2603504",
        "label": "Camocim de São Félix"
      },
      {
        "value": "2603603",
        "label": "Camutanga"
      },
      {
        "value": "2603702",
        "label": "Canhotinho"
      },
      {
        "value": "2603801",
        "label": "Capoeiras"
      },
      {
        "value": "2603900",
        "label": "Carnaíba"
      },
      {
        "value": "2603926",
        "label": "Carnaubeira da Penha"
      },
      {
        "value": "2604007",
        "label": "Carpina"
      },
      {
        "value": "2604106",
        "label": "Caruaru"
      },
      {
        "value": "2604155",
        "label": "Casinhas"
      },
      {
        "value": "2604205",
        "label": "Catende"
      },
      {
        "value": "2604304",
        "label": "Cedro"
      },
      {
        "value": "2604403",
        "label": "Chã de Alegria"
      },
      {
        "value": "2604502",
        "label": "Chã Grande"
      },
      {
        "value": "2604601",
        "label": "Condado"
      },
      {
        "value": "2604700",
        "label": "Correntes"
      },
      {
        "value": "2604809",
        "label": "Cortês"
      },
      {
        "value": "2604908",
        "label": "Cumaru"
      },
      {
        "value": "2605004",
        "label": "Cupira"
      },
      {
        "value": "2605103",
        "label": "Custódia"
      },
      {
        "value": "2605152",
        "label": "Dormentes"
      },
      {
        "value": "2605202",
        "label": "Escada"
      },
      {
        "value": "2605301",
        "label": "Exu"
      },
      {
        "value": "2605400",
        "label": "Feira Nova"
      },
      {
        "value": "2605459",
        "label": "Fernando de Noronha"
      },
      {
        "value": "2605509",
        "label": "Ferreiros"
      },
      {
        "value": "2605608",
        "label": "Flores"
      },
      {
        "value": "2605707",
        "label": "Floresta"
      },
      {
        "value": "2605806",
        "label": "Frei Miguelinho"
      },
      {
        "value": "2605905",
        "label": "Gameleira"
      },
      {
        "value": "2606002",
        "label": "Garanhuns"
      },
      {
        "value": "2606101",
        "label": "Glória do Goitá"
      },
      {
        "value": "2606200",
        "label": "Goiana"
      },
      {
        "value": "2606309",
        "label": "Granito"
      },
      {
        "value": "2606408",
        "label": "Gravatá"
      },
      {
        "value": "2606507",
        "label": "Iati"
      },
      {
        "value": "2606606",
        "label": "Ibimirim"
      },
      {
        "value": "2606705",
        "label": "Ibirajuba"
      },
      {
        "value": "2606804",
        "label": "Igarassu"
      },
      {
        "value": "2606903",
        "label": "Iguaraci"
      },
      {
        "value": "2607000",
        "label": "Inajá"
      },
      {
        "value": "2607109",
        "label": "Ingazeira"
      },
      {
        "value": "2607208",
        "label": "Ipojuca"
      },
      {
        "value": "2607307",
        "label": "Ipubi"
      },
      {
        "value": "2607406",
        "label": "Itacuruba"
      },
      {
        "value": "2607505",
        "label": "Itaíba"
      },
      {
        "value": "2607604",
        "label": "Ilha de Itamaracá"
      },
      {
        "value": "2607653",
        "label": "Itambé"
      },
      {
        "value": "2607703",
        "label": "Itapetim"
      },
      {
        "value": "2607752",
        "label": "Itapissuma"
      },
      {
        "value": "2607802",
        "label": "Itaquitinga"
      },
      {
        "value": "2607901",
        "label": "Jaboatão dos Guararapes"
      },
      {
        "value": "2607950",
        "label": "Jaqueira"
      },
      {
        "value": "2608008",
        "label": "Jataúba"
      },
      {
        "value": "2608057",
        "label": "Jatobá"
      },
      {
        "value": "2608107",
        "label": "João Alfredo"
      },
      {
        "value": "2608206",
        "label": "Joaquim Nabuco"
      },
      {
        "value": "2608255",
        "label": "Jucati"
      },
      {
        "value": "2608305",
        "label": "Jupi"
      },
      {
        "value": "2608404",
        "label": "Jurema"
      },
      {
        "value": "2608453",
        "label": "Lagoa do Carro"
      },
      {
        "value": "2608503",
        "label": "Lagoa de Itaenga"
      },
      {
        "value": "2608602",
        "label": "Lagoa do Ouro"
      },
      {
        "value": "2608701",
        "label": "Lagoa dos Gatos"
      },
      {
        "value": "2608750",
        "label": "Lagoa Grande"
      },
      {
        "value": "2608800",
        "label": "Lajedo"
      },
      {
        "value": "2608909",
        "label": "Limoeiro"
      },
      {
        "value": "2609006",
        "label": "Macaparana"
      },
      {
        "value": "2609105",
        "label": "Machados"
      },
      {
        "value": "2609154",
        "label": "Manari"
      },
      {
        "value": "2609204",
        "label": "Maraial"
      },
      {
        "value": "2609303",
        "label": "Mirandiba"
      },
      {
        "value": "2609402",
        "label": "Moreno"
      },
      {
        "value": "2609501",
        "label": "Nazaré da Mata"
      },
      {
        "value": "2609600",
        "label": "Olinda"
      },
      {
        "value": "2609709",
        "label": "Orobó"
      },
      {
        "value": "2609808",
        "label": "Orocó"
      },
      {
        "value": "2609907",
        "label": "Ouricuri"
      },
      {
        "value": "2610004",
        "label": "Palmares"
      },
      {
        "value": "2610103",
        "label": "Palmeirina"
      },
      {
        "value": "2610202",
        "label": "Panelas"
      },
      {
        "value": "2610301",
        "label": "Paranatama"
      },
      {
        "value": "2610400",
        "label": "Parnamirim"
      },
      {
        "value": "2610509",
        "label": "Passira"
      },
      {
        "value": "2610608",
        "label": "Paudalho"
      },
      {
        "value": "2610707",
        "label": "Paulista"
      },
      {
        "value": "2610806",
        "label": "Pedra"
      },
      {
        "value": "2610905",
        "label": "Pesqueira"
      },
      {
        "value": "2611002",
        "label": "Petrolândia"
      },
      {
        "value": "2611101",
        "label": "Petrolina"
      },
      {
        "value": "2611200",
        "label": "Poção"
      },
      {
        "value": "2611309",
        "label": "Pombos"
      },
      {
        "value": "2611408",
        "label": "Primavera"
      },
      {
        "value": "2611507",
        "label": "Quipapá"
      },
      {
        "value": "2611533",
        "label": "Quixaba"
      },
      {
        "value": "2611606",
        "label": "Recife"
      },
      {
        "value": "2611705",
        "label": "Riacho das Almas"
      },
      {
        "value": "2611804",
        "label": "Ribeirão"
      },
      {
        "value": "2611903",
        "label": "Rio Formoso"
      },
      {
        "value": "2612000",
        "label": "Sairé"
      },
      {
        "value": "2612109",
        "label": "Salgadinho"
      },
      {
        "value": "2612208",
        "label": "Salgueiro"
      },
      {
        "value": "2612307",
        "label": "Saloá"
      },
      {
        "value": "2612406",
        "label": "Sanharó"
      },
      {
        "value": "2612455",
        "label": "Santa Cruz"
      },
      {
        "value": "2612471",
        "label": "Santa Cruz da Baixa Verde"
      },
      {
        "value": "2612505",
        "label": "Santa Cruz do Capibaribe"
      },
      {
        "value": "2612554",
        "label": "Santa Filomena"
      },
      {
        "value": "2612604",
        "label": "Santa Maria da Boa Vista"
      },
      {
        "value": "2612703",
        "label": "Santa Maria do Cambucá"
      },
      {
        "value": "2612802",
        "label": "Santa Terezinha"
      },
      {
        "value": "2612901",
        "label": "São Benedito do Sul"
      },
      {
        "value": "2613008",
        "label": "São Bento do Una"
      },
      {
        "value": "2613107",
        "label": "São Caitano"
      },
      {
        "value": "2613206",
        "label": "São João"
      },
      {
        "value": "2613305",
        "label": "São Joaquim do Monte"
      },
      {
        "value": "2613404",
        "label": "São José da Coroa Grande"
      },
      {
        "value": "2613503",
        "label": "São José do Belmonte"
      },
      {
        "value": "2613602",
        "label": "São José do Egito"
      },
      {
        "value": "2613701",
        "label": "São Lourenço da Mata"
      },
      {
        "value": "2613800",
        "label": "São Vicente Ferrer"
      },
      {
        "value": "2613909",
        "label": "Serra Talhada"
      },
      {
        "value": "2614006",
        "label": "Serrita"
      },
      {
        "value": "2614105",
        "label": "Sertânia"
      },
      {
        "value": "2614204",
        "label": "Sirinhaém"
      },
      {
        "value": "2614303",
        "label": "Moreilândia"
      },
      {
        "value": "2614402",
        "label": "Solidão"
      },
      {
        "value": "2614501",
        "label": "Surubim"
      },
      {
        "value": "2614600",
        "label": "Tabira"
      },
      {
        "value": "2614709",
        "label": "Tacaimbó"
      },
      {
        "value": "2614808",
        "label": "Tacaratu"
      },
      {
        "value": "2614857",
        "label": "Tamandaré"
      },
      {
        "value": "2615003",
        "label": "Taquaritinga do Norte"
      },
      {
        "value": "2615102",
        "label": "Terezinha"
      },
      {
        "value": "2615201",
        "label": "Terra Nova"
      },
      {
        "value": "2615300",
        "label": "Timbaúba"
      },
      {
        "value": "2615409",
        "label": "Toritama"
      },
      {
        "value": "2615508",
        "label": "Tracunhaém"
      },
      {
        "value": "2615607",
        "label": "Trindade"
      },
      {
        "value": "2615706",
        "label": "Triunfo"
      },
      {
        "value": "2615805",
        "label": "Tupanatinga"
      },
      {
        "value": "2615904",
        "label": "Tuparetama"
      },
      {
        "value": "2616001",
        "label": "Venturosa"
      },
      {
        "value": "2616100",
        "label": "Verdejante"
      },
      {
        "value": "2616183",
        "label": "Vertente do Lério"
      },
      {
        "value": "2616209",
        "label": "Vertentes"
      },
      {
        "value": "2616308",
        "label": "Vicência"
      },
      {
        "value": "2616407",
        "label": "Vitória de Santo Antão"
      },
      {
        "value": "2616506",
        "label": "Xexéu"
      }
    ]
